// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2AxcU","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2ZZAC","obliqueLine":"membershipbadge_obliqueLine__10sR6"};